import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { TRATAR_401_SESSAO } from '../../auth/interceptors/sessao-http-context';

/**
 * Quando verdadeiro na requisição, o interceptor não exibe alerta de erro: a tela que fez a
 * chamada assume a apresentação da mensagem (evita alertas duplicados).
 */
export const SUPRIMIR_ALERTA_ERRO = new HttpContextToken<boolean>(() => false);

/**
 * Códigos de regra de negócio (campo `errorCode` do corpo do erro) que a chamada apresenta como aviso,
 * e não como erro: mensagens que eram 'warning' no legado. Os demais códigos continuam como erro.
 */
export const CODIGOS_ALERTA_AVISO = new HttpContextToken<readonly string[]>(() => []);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SUPRIMIR_ALERTA_ERRO)) {
    return next(req);
  }

  const alertService = inject(AlertService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && req.context.get(TRATAR_401_SESSAO)) {
        return throwError(() => error);
      }
      let message = 'Erro inesperado';

      if (error.error?.errors && error.error.errors.length > 0) {
        alertService.errorList(error.error.errors);
      } else {
        if (error.error?.message) {
          message = error.error.message || error.error.detail;
        } else if (error.status === 0) {
          message = 'Erro de conexão com o servidor';
        } else if (error.status >= 500) {
          message = 'Erro interno no servidor';
        } else if (error.status === 401) {
          message = 'Não autorizado';
        } else if (error.status === 403) {
          message = 'Você não tem permissão para essa ação';
        }
        const codigo: unknown = error.error?.errorCode;
        if (typeof codigo === 'string' && req.context.get(CODIGOS_ALERTA_AVISO).includes(codigo)) {
          alertService.warning(message);
        } else {
          alertService.error(message);
        }
      }

      return throwError(() => error);
    })
  );
};
